module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/lung_cancer_title-8766b72f94f0592b98be95b2dfb5eed6.png";